import { Component, inject, Renderer2, ViewEncapsulation } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";

import { Nulled } from "@core/interfaces/core.interface";

import { environment } from "../environments/environment";

@Component({
    standalone: true,
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
})
export class AppComponent {
    readonly #renderer: Renderer2 = inject(Renderer2);

    constructor() {
        if (!environment.production) {
            this.#renderer.addClass(document.body, "test-environment");
        }

        const favIcon: Nulled<HTMLLinkElement> = document.querySelector("#favIcon");
        if (favIcon && environment?.faviconPath) {
            favIcon.href = environment.faviconPath;
        }
    }
}
